import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=a2f66692&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=a2f66692&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f66692')) {
      api.createRecord('a2f66692', component.options)
    } else {
      api.reload('a2f66692', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=a2f66692&", function () {
      api.rerender('a2f66692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teams/_id.vue"
export default component.exports